import { USER_TYPES } from 'shared_DEPRECATED/types/User';

import { useUserMode } from './useUserMode';

export const useIsCoachMode = () => {
  const userMode = useUserMode();

  return userMode === USER_TYPES.COACH;
};
